import { useContext } from "react";
import { AppAgentContext } from "../../context/ContextProvider";
import { Permissions } from "src/types/Permission";

interface IProps {
  children: JSX.Element | JSX.Element[];
  permission: Permissions | Permissions[];
  denied?: JSX.Element | JSX.Element[];
}

const Permission = (props: IProps) => {
  const { state: { session: { user_id, permissions, isAdmin }}} = useContext(AppAgentContext);
  const {permission, children, denied } = props;
  const accessTo = (isAdmin || user_id) && (Array.isArray(permission) ? permission.some(p => permissions[p as any]) : permissions[permission as any]);
  return <>{accessTo ? children : (denied || null)}</>;
}

export default Permission;
